"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.PerformanceTimePeriod = exports.MetricType = exports.PerformanceResolution = exports.TransactionType = exports.DocumentType = exports.FinancialAccountStatus = exports.FinancialAccountType = exports.PortfolioServiceType = exports.Scope = exports.ClientAccountStatus = exports.TradeMethod = exports.TradeAction = exports.ClientAccountRoleType = exports.EmailType = exports.PhoneNumberType = exports.ResidencyType = exports.Gender = exports.Title = exports.AddressType = exports.SourceOfFunds = exports.PensionType = exports.TrusteeType = exports.TrustType = exports.CompanyType = exports.TaxFileNumberExemptionType = exports.ClientAccountType = exports.WorkflowManagerClient = exports.SuperSimplifierAccountsClient = exports.PortfoliosClient = exports.ContactsClient = exports.ClientAccountsClient = exports.ClientAccountIntentsClient = exports.AdvisersClient = exports.AuthorizedApiBase = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const axios_1 = require("axios");
class AuthorizedApiBase {
    constructor() {
        this.authToken = '';
        this.transformOptions = (options) => {
            options.headers = Object.assign(Object.assign({}, options.headers), { Authorization: `Bearer ${this.authToken}` });
            return Promise.resolve(options);
        };
    }
    setAuthToken(token) {
        this.authToken = token;
    }
}
exports.AuthorizedApiBase = AuthorizedApiBase;
class AdvisersClient extends AuthorizedApiBase {
    constructor(baseUrl, instance) {
        super();
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dash.com.au";
    }
    getAdvisers(skip, take, cancelToken) {
        let url_ = this.baseUrl + "/advisers?";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetAdvisers(_response);
        });
    }
    processGetAdvisers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.AdvisersClient = AdvisersClient;
class ClientAccountIntentsClient extends AuthorizedApiBase {
    constructor(baseUrl, instance) {
        super();
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dash.com.au";
    }
    completeOnboardingWizard(key, cancelToken) {
        let url_ = this.baseUrl + "/clientaccountintents/{key}/complete";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCompleteOnboardingWizard(_response);
        });
    }
    processCompleteOnboardingWizard(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getClientAccountIntent(key, cancelToken) {
        let url_ = this.baseUrl + "/clientaccountintents/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetClientAccountIntent(_response);
        });
    }
    processGetClientAccountIntent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    createClientAccountIntent(model, cancelToken) {
        let url_ = this.baseUrl + "/clientaccountintents";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateClientAccountIntent(_response);
        });
    }
    processCreateClientAccountIntent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.ClientAccountIntentsClient = ClientAccountIntentsClient;
class ClientAccountsClient extends AuthorizedApiBase {
    constructor(baseUrl, instance) {
        super();
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dash.com.au";
    }
    getClientAccounts(skip, take, scope, scopeKeys, cancelToken) {
        let url_ = this.baseUrl + "/clientaccounts?";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (scope === undefined)
            throw new Error("The parameter 'scope' must be defined.");
        else if (scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (scopeKeys === undefined)
            throw new Error("The parameter 'scopeKeys' must be defined.");
        else if (scopeKeys !== null)
            scopeKeys && scopeKeys.forEach(item => { url_ += "scopeKeys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetClientAccounts(_response);
        });
    }
    processGetClientAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getClientAccount(key, includeValueOverTime, includeAccounts, cancelToken) {
        let url_ = this.baseUrl + "/clientaccounts/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (includeValueOverTime === undefined || includeValueOverTime === null)
            throw new Error("The parameter 'includeValueOverTime' must be defined and cannot be null.");
        else
            url_ += "includeValueOverTime=" + encodeURIComponent("" + includeValueOverTime) + "&";
        if (includeAccounts === undefined || includeAccounts === null)
            throw new Error("The parameter 'includeAccounts' must be defined and cannot be null.");
        else
            url_ += "includeAccounts=" + encodeURIComponent("" + includeAccounts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetClientAccount(_response);
        });
    }
    processGetClientAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getDocuments(key, skip, take, documentName, documentType, dateFrom, dateTo, cancelToken) {
        let url_ = this.baseUrl + "/clientaccounts/{key}/documents?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (documentName === undefined)
            throw new Error("The parameter 'documentName' must be defined.");
        else if (documentName !== null)
            url_ += "documentName=" + encodeURIComponent("" + documentName) + "&";
        if (documentType === undefined)
            throw new Error("The parameter 'documentType' must be defined.");
        else if (documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (dateFrom === undefined)
            throw new Error("The parameter 'dateFrom' must be defined.");
        else if (dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === undefined)
            throw new Error("The parameter 'dateTo' must be defined.");
        else if (dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDocuments(_response);
        });
    }
    processGetDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.ClientAccountsClient = ClientAccountsClient;
class ContactsClient extends AuthorizedApiBase {
    constructor(baseUrl, instance) {
        super();
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dash.com.au";
    }
    getContacts(skip, take, scope, scopeKeys, cancelToken) {
        let url_ = this.baseUrl + "/contacts?";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (scope === undefined)
            throw new Error("The parameter 'scope' must be defined.");
        else if (scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (scopeKeys === undefined)
            throw new Error("The parameter 'scopeKeys' must be defined.");
        else if (scopeKeys !== null)
            scopeKeys && scopeKeys.forEach(item => { url_ += "scopeKeys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetContacts(_response);
        });
    }
    processGetContacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    verifyIdentityExternally(key, request, cancelToken) {
        let url_ = this.baseUrl + "/contacts/{key}/verifyidentityexternally";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processVerifyIdentityExternally(_response);
        });
    }
    processVerifyIdentityExternally(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            let result401 = null;
            let resultData401 = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getContact(key, cancelToken) {
        let url_ = this.baseUrl + "/contacts/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetContact(_response);
        });
    }
    processGetContact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.ContactsClient = ContactsClient;
class PortfoliosClient extends AuthorizedApiBase {
    constructor(baseUrl, instance) {
        super();
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dash.com.au";
    }
    getPortfolios(skip, take, scope, scopeKey, cancelToken) {
        let url_ = this.baseUrl + "/portfolios?";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (scope === undefined)
            throw new Error("The parameter 'scope' must be defined.");
        else if (scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (scopeKey === undefined)
            throw new Error("The parameter 'scopeKey' must be defined.");
        else if (scopeKey !== null)
            url_ += "scopeKey=" + encodeURIComponent("" + scopeKey) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfolios(_response);
        });
    }
    processGetPortfolios(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getPortfolio(key, includePerformance, includeAccounts, includeRecentDocuments, includeRecentTransactions, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (includePerformance === undefined || includePerformance === null)
            throw new Error("The parameter 'includePerformance' must be defined and cannot be null.");
        else
            url_ += "includePerformance=" + encodeURIComponent("" + includePerformance) + "&";
        if (includeAccounts === undefined || includeAccounts === null)
            throw new Error("The parameter 'includeAccounts' must be defined and cannot be null.");
        else
            url_ += "includeAccounts=" + encodeURIComponent("" + includeAccounts) + "&";
        if (includeRecentDocuments === undefined || includeRecentDocuments === null)
            throw new Error("The parameter 'includeRecentDocuments' must be defined and cannot be null.");
        else
            url_ += "includeRecentDocuments=" + encodeURIComponent("" + includeRecentDocuments) + "&";
        if (includeRecentTransactions === undefined || includeRecentTransactions === null)
            throw new Error("The parameter 'includeRecentTransactions' must be defined and cannot be null.");
        else
            url_ += "includeRecentTransactions=" + encodeURIComponent("" + includeRecentTransactions) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfolio(_response);
        });
    }
    processGetPortfolio(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getPortfolioPerformance(key, compareToBenchmark, timePeriod, fromDate, toDate, skip, take, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/{key}/performance?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (compareToBenchmark === undefined)
            throw new Error("The parameter 'compareToBenchmark' must be defined.");
        else if (compareToBenchmark !== null)
            url_ += "compareToBenchmark=" + encodeURIComponent("" + compareToBenchmark) + "&";
        if (timePeriod === undefined)
            throw new Error("The parameter 'timePeriod' must be defined.");
        else if (timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        if (fromDate === undefined)
            throw new Error("The parameter 'fromDate' must be defined.");
        else if (fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined)
            throw new Error("The parameter 'toDate' must be defined.");
        else if (toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfolioPerformance(_response);
        });
    }
    processGetPortfolioPerformance(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getPortfolioTransactions(key, securityCode, securityName, transactionType, includeCashTransactions, fromDate, toDate, skip, take, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/{key}/transactions?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (securityCode === undefined)
            throw new Error("The parameter 'securityCode' must be defined.");
        else if (securityCode !== null)
            url_ += "securityCode=" + encodeURIComponent("" + securityCode) + "&";
        if (securityName === undefined)
            throw new Error("The parameter 'securityName' must be defined.");
        else if (securityName !== null)
            url_ += "securityName=" + encodeURIComponent("" + securityName) + "&";
        if (transactionType === undefined)
            throw new Error("The parameter 'transactionType' must be defined.");
        else if (transactionType !== null)
            transactionType && transactionType.forEach(item => { url_ += "transactionType=" + encodeURIComponent("" + item) + "&"; });
        if (includeCashTransactions === undefined || includeCashTransactions === null)
            throw new Error("The parameter 'includeCashTransactions' must be defined and cannot be null.");
        else
            url_ += "includeCashTransactions=" + encodeURIComponent("" + includeCashTransactions) + "&";
        if (fromDate === undefined)
            throw new Error("The parameter 'fromDate' must be defined.");
        else if (fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined)
            throw new Error("The parameter 'toDate' must be defined.");
        else if (toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfolioTransactions(_response);
        });
    }
    processGetPortfolioTransactions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getPortfolioAssetClasses(key, asOfDate, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/{key}/assetclasses?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (asOfDate === undefined)
            throw new Error("The parameter 'asOfDate' must be defined.");
        else if (asOfDate !== null)
            url_ += "asOfDate=" + encodeURIComponent(asOfDate ? "" + asOfDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfolioAssetClasses(_response);
        });
    }
    processGetPortfolioAssetClasses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getPortfolioHoldings(key, asOfDate, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/{key}/holdings?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (asOfDate === undefined)
            throw new Error("The parameter 'asOfDate' must be defined.");
        else if (asOfDate !== null)
            url_ += "asOfDate=" + encodeURIComponent(asOfDate ? "" + asOfDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfolioHoldings(_response);
        });
    }
    processGetPortfolioHoldings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getPortfoliosInfo(includeValueOverTime, clientPortfolios, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/infos?";
        if (includeValueOverTime === undefined || includeValueOverTime === null)
            throw new Error("The parameter 'includeValueOverTime' must be defined and cannot be null.");
        else
            url_ += "includeValueOverTime=" + encodeURIComponent("" + includeValueOverTime) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(clientPortfolios);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfoliosInfo(_response);
        });
    }
    processGetPortfoliosInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getMultiPortfolioHoldings(asOfDate, clientPortfolios, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/multiportfolioholdings?";
        if (asOfDate === undefined)
            throw new Error("The parameter 'asOfDate' must be defined.");
        else if (asOfDate !== null)
            url_ += "asOfDate=" + encodeURIComponent(asOfDate ? "" + asOfDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(clientPortfolios);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMultiPortfolioHoldings(_response);
        });
    }
    processGetMultiPortfolioHoldings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getMultiPortfolioAssetClasses(asOfDate, clientPortfolios, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/multiportfolioassetclasses?";
        if (asOfDate === undefined)
            throw new Error("The parameter 'asOfDate' must be defined.");
        else if (asOfDate !== null)
            url_ += "asOfDate=" + encodeURIComponent(asOfDate ? "" + asOfDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(clientPortfolios);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMultiPortfolioAssetClasses(_response);
        });
    }
    processGetMultiPortfolioAssetClasses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getMultiPortfolioPerformance(compareToBenchmark, fromDate, toDate, clientPortfolios, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/multiportfolioperformance?";
        if (compareToBenchmark === undefined)
            throw new Error("The parameter 'compareToBenchmark' must be defined.");
        else if (compareToBenchmark !== null)
            url_ += "compareToBenchmark=" + encodeURIComponent("" + compareToBenchmark) + "&";
        if (fromDate === undefined)
            throw new Error("The parameter 'fromDate' must be defined.");
        else if (fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined)
            throw new Error("The parameter 'toDate' must be defined.");
        else if (toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(clientPortfolios);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMultiPortfolioPerformance(_response);
        });
    }
    processGetMultiPortfolioPerformance(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getPortfoliosTransactions(fromDate, toDate, securityCode, clientPortfolios, cancelToken) {
        let url_ = this.baseUrl + "/portfolios/transactions?";
        if (fromDate === undefined)
            throw new Error("The parameter 'fromDate' must be defined.");
        else if (fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined)
            throw new Error("The parameter 'toDate' must be defined.");
        else if (toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (securityCode === undefined)
            throw new Error("The parameter 'securityCode' must be defined.");
        else if (securityCode !== null)
            url_ += "securityCode=" + encodeURIComponent("" + securityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(clientPortfolios);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPortfoliosTransactions(_response);
        });
    }
    processGetPortfoliosTransactions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getMultiPortfoliosInfo(cancelToken) {
        let url_ = this.baseUrl + "/portfolios/portfoliosinfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMultiPortfoliosInfo(_response);
        });
    }
    processGetMultiPortfoliosInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.PortfoliosClient = PortfoliosClient;
class SuperSimplifierAccountsClient extends AuthorizedApiBase {
    constructor(baseUrl, instance) {
        super();
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dash.com.au";
    }
    getSuperSimpliferAccounts(skip, take, cancelToken) {
        let url_ = this.baseUrl + "/supersimplifieraccounts?";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetSuperSimpliferAccounts(_response);
        });
    }
    processGetSuperSimpliferAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getSuperSimpliferAccount(accountNumber, cancelToken) {
        let url_ = this.baseUrl + "/supersimplifieraccounts/{accountNumber}";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetSuperSimpliferAccount(_response);
        });
    }
    processGetSuperSimpliferAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getContributions(accountNumber, financialYearEndingYear, cancelToken) {
        let url_ = this.baseUrl + "/supersimplifieraccounts/{accountNumber}/contributions?";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        if (financialYearEndingYear === undefined || financialYearEndingYear === null)
            throw new Error("The parameter 'financialYearEndingYear' must be defined and cannot be null.");
        else
            url_ += "financialYearEndingYear=" + encodeURIComponent("" + financialYearEndingYear) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetContributions(_response);
        });
    }
    processGetContributions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    uploadApplication(accountNumber, document, cancelToken) {
        let url_ = this.baseUrl + "/supersimplifieraccounts/{accountNumber}/submitapplication";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(document);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUploadApplication(_response);
        });
    }
    processUploadApplication(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    sendAppForSignature(accountNumber, cancelToken) {
        let url_ = this.baseUrl + "/supersimplifieraccounts/{accountNumber}/sendappforsignature";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSendAppForSignature(_response);
        });
    }
    processSendAppForSignature(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getDocuments(accountNumber, skip, take, cancelToken) {
        let url_ = this.baseUrl + "/supersimplifieraccounts/{accountNumber}/documents?";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDocuments(_response);
        });
    }
    processGetDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    getApplicationForm(accountNumber, cancelToken) {
        let url_ = this.baseUrl + "/supersimplifieraccounts/{accountNumber}/getappform";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetApplicationForm(_response);
        });
    }
    processGetApplicationForm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.SuperSimplifierAccountsClient = SuperSimplifierAccountsClient;
class WorkflowManagerClient extends AuthorizedApiBase {
    constructor(baseUrl, instance) {
        super();
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dash.com.au";
    }
    getWorkflowStatus(id, cancelToken) {
        let url_ = this.baseUrl + "/workflowmanager/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetWorkflowStatus(_response);
        });
    }
    processGetWorkflowStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.WorkflowManagerClient = WorkflowManagerClient;
var ClientAccountType;
(function (ClientAccountType) {
    ClientAccountType["Individual"] = "Individual";
    ClientAccountType["Joint"] = "Joint";
    ClientAccountType["Superannuation"] = "Superannuation";
    ClientAccountType["Pension"] = "Pension";
    ClientAccountType["Smsf"] = "Smsf";
    ClientAccountType["Trust"] = "Trust";
    ClientAccountType["Company"] = "Company";
})(ClientAccountType = exports.ClientAccountType || (exports.ClientAccountType = {}));
var TaxFileNumberExemptionType;
(function (TaxFileNumberExemptionType) {
    TaxFileNumberExemptionType["NotProvided"] = "NotProvided";
    TaxFileNumberExemptionType["InvestorUnder16"] = "InvestorUnder16";
    TaxFileNumberExemptionType["InvestorPensioner"] = "InvestorPensioner";
    TaxFileNumberExemptionType["InvestorHasOtherEligiblePensionOrBenefit"] = "InvestorHasOtherEligiblePensionOrBenefit";
    TaxFileNumberExemptionType["EntityNotRequiredToLodgeTaxReturn"] = "EntityNotRequiredToLodgeTaxReturn";
    TaxFileNumberExemptionType["InvestorProvidingConsumerOrBusinessFinance"] = "InvestorProvidingConsumerOrBusinessFinance";
    TaxFileNumberExemptionType["NorfolkIslandResident"] = "NorfolkIslandResident";
    TaxFileNumberExemptionType["NonResident"] = "NonResident";
    TaxFileNumberExemptionType["SyntacticallyInvalid"] = "SyntacticallyInvalid";
})(TaxFileNumberExemptionType = exports.TaxFileNumberExemptionType || (exports.TaxFileNumberExemptionType = {}));
var CompanyType;
(function (CompanyType) {
    CompanyType["Public"] = "Public";
    CompanyType["Private"] = "Private";
})(CompanyType = exports.CompanyType || (exports.CompanyType = {}));
var TrustType;
(function (TrustType) {
    TrustType["Family"] = "Family";
    TrustType["Unit"] = "Unit";
    TrustType["Superannuation"] = "Superannuation";
})(TrustType = exports.TrustType || (exports.TrustType = {}));
var TrusteeType;
(function (TrusteeType) {
    TrusteeType["Individual"] = "Individual";
    TrusteeType["Corporate"] = "Corporate";
})(TrusteeType = exports.TrusteeType || (exports.TrusteeType = {}));
var PensionType;
(function (PensionType) {
    PensionType["AccountBased"] = "AccountBased";
    PensionType["TransitionToRetirement"] = "TransitionToRetirement";
    PensionType["TermAllocated"] = "TermAllocated";
})(PensionType = exports.PensionType || (exports.PensionType = {}));
var SourceOfFunds;
(function (SourceOfFunds) {
    SourceOfFunds["SalaryWages"] = "SalaryWages";
    SourceOfFunds["BusinessIncome"] = "BusinessIncome";
    SourceOfFunds["InvestmentIncome"] = "InvestmentIncome";
    SourceOfFunds["RentalIncome"] = "RentalIncome";
    SourceOfFunds["CompensationPayment"] = "CompensationPayment";
    SourceOfFunds["SaleOfAssets"] = "SaleOfAssets";
    SourceOfFunds["Gift"] = "Gift";
    SourceOfFunds["Inheritance"] = "Inheritance";
    SourceOfFunds["SuperannuationPension"] = "SuperannuationPension";
    SourceOfFunds["Windfall"] = "Windfall";
})(SourceOfFunds = exports.SourceOfFunds || (exports.SourceOfFunds = {}));
var AddressType;
(function (AddressType) {
    AddressType["PhysicalOrHomeOrBusiness"] = "PhysicalOrHomeOrBusiness";
    AddressType["Mailing"] = "Mailing";
    AddressType["RegisteredAsic"] = "RegisteredAsic";
    AddressType["RegisteredChess"] = "RegisteredChess";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var Title;
(function (Title) {
    Title["Mr"] = "Mr";
    Title["Mrs"] = "Mrs";
    Title["Ms"] = "Ms";
    Title["Miss"] = "Miss";
    Title["Dr"] = "Dr";
})(Title = exports.Title || (exports.Title = {}));
var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
    Gender["Unspecified"] = "Unspecified";
})(Gender = exports.Gender || (exports.Gender = {}));
var ResidencyType;
(function (ResidencyType) {
    ResidencyType["AustralianResident"] = "AustralianResident";
    ResidencyType["ForeignResident"] = "ForeignResident";
})(ResidencyType = exports.ResidencyType || (exports.ResidencyType = {}));
var PhoneNumberType;
(function (PhoneNumberType) {
    PhoneNumberType["Work"] = "Work";
    PhoneNumberType["Home"] = "Home";
    PhoneNumberType["Mobile"] = "Mobile";
})(PhoneNumberType = exports.PhoneNumberType || (exports.PhoneNumberType = {}));
var EmailType;
(function (EmailType) {
    EmailType["Work"] = "Work";
    EmailType["Home"] = "Home";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
var ClientAccountRoleType;
(function (ClientAccountRoleType) {
    ClientAccountRoleType["Adviser"] = "Adviser";
    ClientAccountRoleType["Beneficiary"] = "Beneficiary";
    ClientAccountRoleType["Contact"] = "Contact";
    ClientAccountRoleType["Trustee"] = "Trustee";
    ClientAccountRoleType["Relative"] = "Relative";
    ClientAccountRoleType["AccountHolder"] = "AccountHolder";
    ClientAccountRoleType["TrustSettler"] = "TrustSettler";
    ClientAccountRoleType["AuthorisedSignatory"] = "AuthorisedSignatory";
    ClientAccountRoleType["CompanyOfficer"] = "CompanyOfficer";
    ClientAccountRoleType["Chairperson"] = "Chairperson";
    ClientAccountRoleType["Member"] = "Member";
    ClientAccountRoleType["Shareholder"] = "Shareholder";
    ClientAccountRoleType["AfslManager"] = "AfslManager";
    ClientAccountRoleType["PracticeManager"] = "PracticeManager";
    ClientAccountRoleType["Group"] = "Group";
    ClientAccountRoleType["Accountant"] = "Accountant";
    ClientAccountRoleType["CrmEmail"] = "CrmEmail";
})(ClientAccountRoleType = exports.ClientAccountRoleType || (exports.ClientAccountRoleType = {}));
var TradeAction;
(function (TradeAction) {
    TradeAction["Buy"] = "Buy";
    TradeAction["Sell"] = "Sell";
    TradeAction["SellAll"] = "SellAll";
})(TradeAction = exports.TradeAction || (exports.TradeAction = {}));
var TradeMethod;
(function (TradeMethod) {
    TradeMethod["Units"] = "Units";
    TradeMethod["Dollar"] = "Dollar";
    TradeMethod["Percentage"] = "Percentage";
})(TradeMethod = exports.TradeMethod || (exports.TradeMethod = {}));
var ClientAccountStatus;
(function (ClientAccountStatus) {
    ClientAccountStatus["Pending"] = "Pending";
    ClientAccountStatus["Active"] = "Active";
    ClientAccountStatus["Terminated"] = "Terminated";
    ClientAccountStatus["WaitingForApproval"] = "WaitingForApproval";
    ClientAccountStatus["Stalled"] = "Stalled";
    ClientAccountStatus["DatafeedActive"] = "DatafeedActive";
})(ClientAccountStatus = exports.ClientAccountStatus || (exports.ClientAccountStatus = {}));
var Scope;
(function (Scope) {
    Scope["Afsl"] = "Afsl";
    Scope["ClientAccount"] = "ClientAccount";
    Scope["Practice"] = "Practice";
    Scope["Adviser"] = "Adviser";
})(Scope = exports.Scope || (exports.Scope = {}));
var PortfolioServiceType;
(function (PortfolioServiceType) {
    PortfolioServiceType["ManagedDiscretionaryAccount"] = "ManagedDiscretionaryAccount";
    PortfolioServiceType["IndividuallyManagedAccount"] = "IndividuallyManagedAccount";
    PortfolioServiceType["Personal"] = "Personal";
    PortfolioServiceType["Unlisted"] = "Unlisted";
    PortfolioServiceType["StatementOfAdvice"] = "StatementOfAdvice";
    PortfolioServiceType["Wholesale"] = "Wholesale";
})(PortfolioServiceType = exports.PortfolioServiceType || (exports.PortfolioServiceType = {}));
var FinancialAccountType;
(function (FinancialAccountType) {
    FinancialAccountType["DepositAtCall"] = "DepositAtCall";
    FinancialAccountType["DepositCma"] = "DepositCma";
    FinancialAccountType["DepositTd"] = "DepositTd";
    FinancialAccountType["SecurityBond"] = "SecurityBond";
    FinancialAccountType["SecurityMf"] = "SecurityMf";
    FinancialAccountType["SecurityAsx"] = "SecurityAsx";
    FinancialAccountType["UXchange"] = "UXchange";
    FinancialAccountType["UnlistedAssets"] = "UnlistedAssets";
    FinancialAccountType["Administration"] = "Administration";
    FinancialAccountType["InvestmentAccount"] = "InvestmentAccount";
    FinancialAccountType["BankAccount"] = "BankAccount";
    FinancialAccountType["SecurityInternational"] = "SecurityInternational";
    FinancialAccountType["DirectAssets"] = "DirectAssets";
})(FinancialAccountType = exports.FinancialAccountType || (exports.FinancialAccountType = {}));
var FinancialAccountStatus;
(function (FinancialAccountStatus) {
    FinancialAccountStatus["Active"] = "Active";
    FinancialAccountStatus["Inactive"] = "Inactive";
    FinancialAccountStatus["Matured"] = "Matured";
    FinancialAccountStatus["Pending"] = "Pending";
    FinancialAccountStatus["Sold"] = "Sold";
    FinancialAccountStatus["Terminated"] = "Terminated";
    FinancialAccountStatus["Suspended"] = "Suspended";
    FinancialAccountStatus["Removed"] = "Removed";
    FinancialAccountStatus["Open"] = "Open";
    FinancialAccountStatus["Archived"] = "Archived";
    FinancialAccountStatus["DocumentsRequired"] = "DocumentsRequired";
    FinancialAccountStatus["Proforma"] = "Proforma";
    FinancialAccountStatus["WaitingForApproval"] = "WaitingForApproval";
    FinancialAccountStatus["DataFeedActive"] = "DataFeedActive";
    FinancialAccountStatus["Delisted"] = "Delisted";
    FinancialAccountStatus["Closed"] = "Closed";
    FinancialAccountStatus["Dormant"] = "Dormant";
})(FinancialAccountStatus = exports.FinancialAccountStatus || (exports.FinancialAccountStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["Afsl"] = "Afsl";
    DocumentType["MdaAgreement"] = "MdaAgreement";
    DocumentType["AustralianPassport"] = "AustralianPassport";
    DocumentType["AustralianCitizenshipCertificate"] = "AustralianCitizenshipCertificate";
    DocumentType["AustralianTaxOfficeNotice"] = "AustralianTaxOfficeNotice";
    DocumentType["BirthCertificateAustralianOrForeign"] = "BirthCertificateAustralianOrForeign";
    DocumentType["MedicareCard"] = "MedicareCard";
    DocumentType["CentreLinkPensionCard"] = "CentreLinkPensionCard";
    DocumentType["CurrentAustralianDriversLicence"] = "CurrentAustralianDriversLicence";
    DocumentType["CurrentForeignDriversLicence"] = "CurrentForeignDriversLicence";
    DocumentType["CurrentForeignPassport"] = "CurrentForeignPassport";
    DocumentType["OtherBankStatements"] = "OtherBankStatements";
    DocumentType["ProofOfAgeCardIssuedUnderLawOfAnAustralianStateOrTerritory"] = "ProofOfAgeCardIssuedUnderLawOfAnAustralianStateOrTerritory";
    DocumentType["PublicUtilityRecordsBillSighted"] = "PublicUtilityRecordsBillSighted";
    DocumentType["NavAssetDocument"] = "NavAssetDocument";
    DocumentType["TrustDeed"] = "TrustDeed";
    DocumentType["CompanyStatement"] = "CompanyStatement";
    DocumentType["AmmApplicationForm"] = "AmmApplicationForm";
    DocumentType["InvestmentProgramTemplate"] = "InvestmentProgramTemplate";
    DocumentType["DesktopBrokerTppApplicationform"] = "DesktopBrokerTppApplicationform";
    DocumentType["MacquarieCmaThirdPartyAuthorityForm"] = "MacquarieCmaThirdPartyAuthorityForm";
    DocumentType["MacquarieCmaTermsAndConditions"] = "MacquarieCmaTermsAndConditions";
    DocumentType["DesktopBrokerTermsAndConditions"] = "DesktopBrokerTermsAndConditions";
    DocumentType["DesktopBrokerFsg"] = "DesktopBrokerFsg";
    DocumentType["OpenMarketsFinancialServicesGuide"] = "OpenMarketsFinancialServicesGuide";
    DocumentType["StatementOfAdvice"] = "StatementOfAdvice";
    DocumentType["RecordOfAdvice"] = "RecordOfAdvice";
    DocumentType["ValidationType"] = "ValidationType";
    DocumentType["Report"] = "Report";
    DocumentType["ImaDocument"] = "ImaDocument";
    DocumentType["Instruction"] = "Instruction";
    DocumentType["WithdrawalCma"] = "WithdrawalCma";
    DocumentType["UserGuides"] = "UserGuides";
    DocumentType["Other"] = "Other";
    DocumentType["MdaInvestmentProgramTemplate"] = "MdaInvestmentProgramTemplate";
    DocumentType["AccrualPushDownIncome"] = "AccrualPushDownIncome";
    DocumentType["XplanExtract"] = "XplanExtract";
    DocumentType["FxExchangeData"] = "FxExchangeData";
    DocumentType["UxChangeApplicationForm"] = "UxChangeApplicationForm";
    DocumentType["UxInSpecieTransfer"] = "UxInSpecieTransfer";
    DocumentType["SuperSimplifierMemberApplicationFormPension"] = "SuperSimplifierMemberApplicationFormPension";
    DocumentType["SuperSimplifierMemberApplicationFormSuper"] = "SuperSimplifierMemberApplicationFormSuper";
    DocumentType["UxChangeApplicationformForJointAccounts"] = "UxChangeApplicationformForJointAccounts";
    DocumentType["ModelResearch"] = "ModelResearch";
    DocumentType["FeeDisclosure"] = "FeeDisclosure";
    DocumentType["ClientProposal"] = "ClientProposal";
    DocumentType["ClientProposalTemplate"] = "ClientProposalTemplate";
    DocumentType["CorpEventTemplate"] = "CorpEventTemplate";
    DocumentType["Email"] = "Email";
    DocumentType["OngoingFeeConsent"] = "OngoingFeeConsent";
    DocumentType["OpenMarketsNonMdaClientAuthority"] = "OpenMarketsNonMdaClientAuthority";
    DocumentType["SuperSimplifierCorrespondenceFromAdministrator"] = "SuperSimplifierCorrespondenceFromAdministrator";
    DocumentType["IdentifyVerificationCertificate"] = "IdentifyVerificationCertificate";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["CapitalReturn"] = "CapitalReturn";
    TransactionType["AdjustmentDown"] = "AdjustmentDown";
    TransactionType["AdjustmentUp"] = "AdjustmentUp";
    TransactionType["BenefitPaymentLumpSum"] = "BenefitPaymentLumpSum";
    TransactionType["BenefitPaymentPension"] = "BenefitPaymentPension";
    TransactionType["BonusIssue"] = "BonusIssue";
    TransactionType["Commutation"] = "Commutation";
    TransactionType["ContributionEmployerSg"] = "ContributionEmployerSg";
    TransactionType["ContributionPersonal"] = "ContributionPersonal";
    TransactionType["ContributionSalSacrifice"] = "ContributionSalSacrifice";
    TransactionType["ContributionSpouse"] = "ContributionSpouse";
    TransactionType["Expense"] = "Expense";
    TransactionType["FeeAccounting"] = "FeeAccounting";
    TransactionType["FeeActuarial"] = "FeeActuarial";
    TransactionType["FeeAdviser"] = "FeeAdviser";
    TransactionType["FeeAuditor"] = "FeeAuditor";
    TransactionType["FeeBank"] = "FeeBank";
    TransactionType["FeeEstablishment"] = "FeeEstablishment";
    TransactionType["FeeFundAdministration"] = "FeeFundAdministration";
    TransactionType["FeeGeneralInterest"] = "FeeGeneralInterest";
    TransactionType["FeeInvestmentFeeRebate"] = "FeeInvestmentFeeRebate";
    TransactionType["FeeInvestmentManagement"] = "FeeInvestmentManagement";
    TransactionType["FeeLegal"] = "FeeLegal";
    TransactionType["FeeRegulatory"] = "FeeRegulatory";
    TransactionType["FeeTrustee"] = "FeeTrustee";
    TransactionType["Fine"] = "Fine";
    TransactionType["IncomeDistributionCash"] = "IncomeDistributionCash";
    TransactionType["IncomeDistributionDrp"] = "IncomeDistributionDrp";
    TransactionType["IncomeDividendCash"] = "IncomeDividendCash";
    TransactionType["IncomeDividendDrp"] = "IncomeDividendDrp";
    TransactionType["IncomeForeign"] = "IncomeForeign";
    TransactionType["IncomeRent"] = "IncomeRent";
    TransactionType["InterestCommissionRebate"] = "InterestCommissionRebate";
    TransactionType["InterestPaid"] = "InterestPaid";
    TransactionType["InterestPenaltyInterestPaid"] = "InterestPenaltyInterestPaid";
    TransactionType["InterestReceived"] = "InterestReceived";
    TransactionType["InternalCashMovement"] = "InternalCashMovement";
    TransactionType["OpeningBalanceAdjustment"] = "OpeningBalanceAdjustment";
    TransactionType["PremiumLife"] = "PremiumLife";
    TransactionType["PremiumRisk"] = "PremiumRisk";
    TransactionType["PurchaseReinvestment"] = "PurchaseReinvestment";
    TransactionType["Reversal"] = "Reversal";
    TransactionType["RightsIssue"] = "RightsIssue";
    TransactionType["SwitchIn"] = "SwitchIn";
    TransactionType["SwitchOut"] = "SwitchOut";
    TransactionType["TaxBas"] = "TaxBas";
    TransactionType["TaxBenefitPayment"] = "TaxBenefitPayment";
    TransactionType["TaxContribution"] = "TaxContribution";
    TransactionType["TaxPayg"] = "TaxPayg";
    TransactionType["TaxRebate"] = "TaxRebate";
    TransactionType["TaxRefund"] = "TaxRefund";
    TransactionType["TaxStampDuty"] = "TaxStampDuty";
    TransactionType["TaxSurcharge"] = "TaxSurcharge";
    TransactionType["TransferIn"] = "TransferIn";
    TransactionType["TransferOut"] = "TransferOut";
    TransactionType["Withdrawal"] = "Withdrawal";
    TransactionType["Buy"] = "Buy";
    TransactionType["Application"] = "Application";
    TransactionType["Interest"] = "Interest";
    TransactionType["IncomeTax"] = "IncomeTax";
    TransactionType["Property"] = "Property";
    TransactionType["InsurancePremium"] = "InsurancePremium";
    TransactionType["CancelBuy"] = "CancelBuy";
    TransactionType["CancelSell"] = "CancelSell";
    TransactionType["BpayWithdrawal"] = "BpayWithdrawal";
    TransactionType["BpayDeposit"] = "BpayDeposit";
    TransactionType["Deposit"] = "Deposit";
    TransactionType["WithdrawalBankTrf"] = "WithdrawalBankTrf";
    TransactionType["PeriodicalPaymentDebit"] = "PeriodicalPaymentDebit";
    TransactionType["ChequeBook"] = "ChequeBook";
    TransactionType["RebateOfAdviserCommission"] = "RebateOfAdviserCommission";
    TransactionType["RTGSApplications"] = "RTGSApplications";
    TransactionType["ReturnedCheque"] = "ReturnedCheque";
    TransactionType["ReturnedChequeCharge"] = "ReturnedChequeCharge";
    TransactionType["PaperStatementFeeAssisted"] = "PaperStatementFeeAssisted";
    TransactionType["DepositAgt"] = "DepositAgt";
    TransactionType["AccountingFee"] = "AccountingFee";
    TransactionType["DepositCheque"] = "DepositCheque";
    TransactionType["BankCheque"] = "BankCheque";
    TransactionType["BankChequeFee"] = "BankChequeFee";
    TransactionType["Placement"] = "Placement";
    TransactionType["InterestAccrual"] = "InterestAccrual";
    TransactionType["SaleRedemption"] = "SaleRedemption";
    TransactionType["Purchase"] = "Purchase";
    TransactionType["Acquisition"] = "Acquisition";
    TransactionType["Investment"] = "Investment";
    TransactionType["MemberContribution"] = "MemberContribution";
    TransactionType["FeeRefund"] = "FeeRefund";
    TransactionType["OpeningBalance"] = "OpeningBalance";
    TransactionType["AuditLetterFeeAssisted"] = "AuditLetterFeeAssisted";
    TransactionType["ExpenseRent"] = "ExpenseRent";
    TransactionType["MemberInsurancePremium"] = "MemberInsurancePremium";
    TransactionType["FundAdministrationFee"] = "FundAdministrationFee";
    TransactionType["BankFee"] = "BankFee";
    TransactionType["InvestmentManagementFee"] = "InvestmentManagementFee";
    TransactionType["AccountancyFee"] = "AccountancyFee";
    TransactionType["DrawdownPostJun07TaxComponents"] = "DrawdownPostJun07TaxComponents";
    TransactionType["BankInterestPaid"] = "BankInterestPaid";
    TransactionType["UnlistedSecurityDisposal"] = "UnlistedSecurityDisposal";
    TransactionType["BankStatementLineItem"] = "BankStatementLineItem";
    TransactionType["RolloverIn"] = "RolloverIn";
    TransactionType["BankFeeRefund"] = "BankFeeRefund";
    TransactionType["RolloverOut"] = "RolloverOut";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var PerformanceResolution;
(function (PerformanceResolution) {
    PerformanceResolution["Auto"] = "Auto";
    PerformanceResolution["Daily"] = "Daily";
    PerformanceResolution["Monthly"] = "Monthly";
})(PerformanceResolution = exports.PerformanceResolution || (exports.PerformanceResolution = {}));
var MetricType;
(function (MetricType) {
    MetricType["Amount"] = "Amount";
    MetricType["Percentage"] = "Percentage";
})(MetricType = exports.MetricType || (exports.MetricType = {}));
var PerformanceTimePeriod;
(function (PerformanceTimePeriod) {
    PerformanceTimePeriod["OneMonth"] = "OneMonth";
    PerformanceTimePeriod["ThreeMonth"] = "ThreeMonth";
    PerformanceTimePeriod["SixMonth"] = "SixMonth";
    PerformanceTimePeriod["OneYear"] = "OneYear";
    PerformanceTimePeriod["ThreeYear"] = "ThreeYear";
    PerformanceTimePeriod["Max"] = "Max";
})(PerformanceTimePeriod = exports.PerformanceTimePeriod || (exports.PerformanceTimePeriod = {}));
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
